import {combineReducers} from "redux";
import {loadingBarReducer} from "react-redux-loading-bar";

import toastReducer from "./toastReducer";
import tabPanelReducer from "./tabPanelReducer";
import loadingReducer from "./loadingReducer";
import drawerNotify from "./drawerNotify";
import chatReducer from "./chatReducer";
import processSelectedReducer from "./processSelectedReducer";
import companyReducer from "./companyReducer";
import courierReducer from "./courierReducer";
import deconsolidationReducer from "./deconsolidationReducer";
import processesReducer from "./processesReducer";
import apiFilterReducer from "./apiFilterReducer";
import sidebarReducer from "./sidebarReducer";
import userInfoReducer from "./userInfoReducer";
import alertMessageReducer from "./alertMessageReducer";
import modalDeleteSpecialRuleReducer from "./modalDeleteSpecialRuleReducer";
import dashboardFiltersReducer from "./dashboardFiltersReducer";
import tasksProjectReducer from "./tasksProjectReducer";
import activitiesReducer from "./activitiesReducer";
import genericTableFilterReducer from "store/reducers/genericTableFilterReducer";
import taskDetailsReducer from "./taskDetailsReducer";
import pendingEmailsReducer from "./pendingEmailsReducer";

const rootReducer = combineReducers({
  stateToast: toastReducer,
  stateTabPanel: tabPanelReducer,
  stateLoading: loadingReducer,
  stateDrawerNotify: drawerNotify,
  stateChat: chatReducer,
  stateProcessSelected: processSelectedReducer,
  stateCompany: companyReducer,
  stateCourier: courierReducer,
  stateDeconsolidation: deconsolidationReducer,
  stateProcessesReducer: processesReducer,
  stateApiFilterReducer: apiFilterReducer,
  stateSidebar: sidebarReducer,
  stateUserInfo: userInfoReducer,
  stateAlertMessage: alertMessageReducer,
  loadingBar: loadingBarReducer,
  stateModalDeleteSpecialRuleReducer: modalDeleteSpecialRuleReducer,
  stateDashboardFilter: dashboardFiltersReducer,
  stateTasksProjectReducer: tasksProjectReducer,
  stateActivitiesReducer: activitiesReducer,
  stateGenericTableFilter: genericTableFilterReducer,
  stateTaskDetailsReducer: taskDetailsReducer,
  statePendingEmails: pendingEmailsReducer,
});

export default rootReducer;
